export default __webpack_public_path__ + "static/media/Our-expert-team-will-reach-you-soon.fb7c8c8b.png";